import Question, { Answer } from '../models/Question';
import axiosClient from './axiosClient';

export const getQuestions = async (): Promise<Question[]> => {
  try {
    const { data } = await axiosClient.get(`/jobquest`);
    return data.questions;
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const sendQuestions = async (answer: { questions: Answer[] }): Promise<{ data: { id: number } }> => {
  try {
    return await axiosClient.post(`/postulation`, answer);
  } catch (error: any) {
    return Promise.reject(error);
  }
};

export const sendCV = async (id: number, cv?: File): Promise<void> => {
  if (!cv) return;
  try {
    const formData = new FormData();
    formData.append('file', cv);
    await axiosClient.post(`/postulation/${id}/cv`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  } catch (error) {
    console.error('Error occurred while sending CV:', error);
    throw new Error('Failed to send CV. Please try again later.');
  }
};
